<script>
import BottomNavigation from "@/components/assetComponents/BottomNavigation.vue";
import Swal from "sweetalert2";
import {useStore} from "vuex";
import NavbarPage from "@/components/assetComponents/NavbarPage.vue";
import FooterPage from "@/components/assetComponents/FooterPage.vue";

export default {
  name: "ProfilePage",
  components: {FooterPage, NavbarPage, BottomNavigation},

  setup() {

    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    let store = useStore()


    function log_out() {

      Swal.fire({
        title: "آیا میخواهید از حسابتان خارج شوید؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بله خارج میشوم",
        cancelButtonText: "منصرف شدم!"
      }).then((result) => {
        if (result.isConfirmed) {

          store.commit('EmptyBasket')
          localStorage.clear()
          store.commit('empty_state')
          window.location.href = "LoginPage"

        }
      });

    }

    return {

      log_out,

    }
  }

}
</script>

<template>

  <div id="main" class="bg-main">
    <div class="">
      <div class="div-top-arrow bg-color d-flex align-items-center">
        <div class="d-flex align-items-center">
          <p class="m-0">
            کاربری
          </p>

          <router-link :to="{name:'HomePage'}" class="text-decoration-none">
            <img class="svg-arrow" src="../assets/img/back.svg" alt="">
          </router-link>
        </div>
      </div>
      <br>
      <br>
      <br>

      <div class="p-body mt-2">

        <router-link :to="{name:'MyProfile'}" class="animate__animated animate__fadeInUpBig a_link p-3 bg-white rounded-3 d-flex align-items-center mb-3">
          <img class="mx-2" style="width: 25px;height: 25px" src="../assets/img/user.svg" alt="">

          <p class="m-0 font-4">
            پروفایل من
          </p>
        </router-link>

        <router-link :to="{name:'ProfileExecutives'}" class="animate__animated animate__fadeInUpBig a_link p-3 bg-white rounded-4 d-flex align-items-center mb-3">
          <img class="mx-2" style="width: 25px;height: 25px" src="../assets/img/businessman.svg" alt="">

          <p class="m-0 font-4">
            پروفایل مجری
          </p>
        </router-link>

        <router-link :to="{name: 'MarkProducts'}" class="animate__animated animate__fadeInUpBig a_link p-3 bg-white rounded-4 d-flex align-items-center mb-3">
          <img class="mx-2" style="width: 25px;height: 25px" src="../assets/img/bokmark_profile.svg" alt="">

          <p class="m-0 font-4">
            نشان شده ها
          </p>
        </router-link>

        <router-link :to="{name:'MyOrders'}" class="animate__animated animate__fadeInUpBig a_link p-3 bg-white rounded-4 d-flex align-items-center mb-3">
          <img class="mx-2" style="width: 25px;height: 25px" src="../assets/img/shopping-bag_profile.svg" alt="">

          <p class="m-0 font-4">
            سفارشات من
          </p>
        </router-link>

        <router-link :to="{name:'MyWallet'}" class="animate__animated animate__fadeInUpBig a_link p-3 bg-white rounded-4 d-flex align-items-center mb-3">
          <img class="mx-2" style="width: 25px;height: 25px" src="../assets/img/wallet_profile.svg" alt="">

          <p class="m-0 font-4">
            کیف پول و پرداخت ها
          </p>
        </router-link>

        <router-link :to="{name:'MyAdvers'}" class="animate__animated animate__fadeInUpBig a_link p-3 bg-white rounded-4 d-flex align-items-center mb-3">
          <img class="mx-2" style="width: 25px;height: 25px" src="../assets/img/search_1_.svg" alt="">

          <p class="m-0 font-4">
            آگهی های من
          </p>
        </router-link>

        <router-link to="BuyEducations" class="animate__animated animate__fadeInUpBig a_link p-3 bg-white rounded-4 d-flex align-items-center mb-3">
          <img class="mx-2" style="width: 25px;height: 25px" src="../assets/img/webinar.svg" alt="">

          <p class="m-0 font-4">
            دوره های خریداری شده
          </p>
        </router-link>

        <router-link :to="{name: 'RulesPage' , params:{action:'ruls'}}" class="animate__animated animate__fadeInUpBig a_link p-3 bg-white rounded-4 d-flex align-items-center mb-3">
          <img class="mx-2" style="width: 25px;height: 25px" src="../assets/img/updated.svg" alt="">

          <p class="m-0 font-4">
            قوانین و مقررات
          </p>
        </router-link>

        <router-link :to="{name: 'RulesPage' , params:{action:'about_us'}}" class="animate__animated animate__fadeInUpBig a_link p-3 bg-white rounded-4 d-flex align-items-center mb-3">
          <img class="mx-2" style="width: 25px;height: 25px" src="../assets/img/team.svg" alt="">

          <p class="m-0 font-4">
            درباره ما
          </p>
        </router-link>

        <router-link to="SupportPage" class="animate__animated animate__fadeInUpBig a_link p-3 bg-white rounded-4 d-flex align-items-center mb-3">
          <img class="mx-2" style="width: 25px;height: 25px" src="../assets/img/phone-call.svg" alt="">

          <p class="m-0 font-4">
            ارتباط با پشتیبانی
          </p>
        </router-link>

        <a href="https://decoban.ir/assets/app/Decoban.apk" class="animate__animated animate__fadeInUpBig a_link p-3 bg-white rounded-4 d-flex align-items-center mb-3">
          <img class="mx-2" style="width: 25px;height: 25px;object-fit: fill" src="../assets/img/64px-Download-Icon.png" alt="">

          <p class="m-0 font-5">
            دانلود اپلیکیشن
          </p>
        </a>

        <a href="https://decoban.ir/assets/app/DecobanShop.apk" class="animate__animated animate__fadeInUpBig a_link p-3 bg-white rounded-4 d-flex align-items-center mb-3">
          <img class="mx-2" style="width: 25px;height: 25px;object-fit: fill" src="../assets/img/64px-Download-Icon.png" alt="">

          <p class="m-0 font-5">
            دانلود اپلیکیشن فروشگاه
          </p>
        </a>

        <a href="https://shop.decoban.ir" target="_blank" class="animate__animated animate__fadeInUpBig a_link p-3 bg-white rounded-4 d-flex align-items-center mb-3">
          <img class="mx-2" style="width: 1.5rem;;object-fit: fill" src="../assets/img/user-icon-q8s7fb75oej4ozz4h9m73qm9tdlufkjmqeqo2ipgzo.jpg" alt="">

          <p class="m-0 font-5">
            ورود به وب اپلیکیشن فروشگاه
          </p>
        </a>

        <div @click="log_out" class="animate__animated animate__fadeInUpBig a_link p-3 bg-white rounded-4 d-flex align-items-center mb-3">
          <img class="mx-2" style="width: 25px;height: 25px" src="../assets/img/enter.svg" alt="">

          <p class="m-0 font-4">
            خروج از اپلیکیشن
          </p>
        </div>

      </div>
      <br>
    </div>
    <BottomNavigation></BottomNavigation>
  </div>

  <div id="web" class="bg-main">
   <NavbarPage></NavbarPage>
    <div style="background-color: white" class="rounded-4 font-bold font-color p-3 mb-3 w-75 ma-auto">پروفایل</div>

    <div class="animate__animated animate__fadeIn p-body mt-2 w-75 ma-auto bg-white p-5 rounded-4">

      <router-link :to="{name:'MyProfile'}" class="a_link p-3 bg-white rounded-4 d-flex align-items-center mb-3 shadow-costom">
        <img class="mx-2" style="width: 25px;height: 25px;object-fit: fill" src="../assets/img/user.svg" alt="">

        <p class="m-0 font-5">
          پروفایل من
        </p>
      </router-link>

      <router-link :to="{name:'ProfileExecutives'}" class="a_link p-3 bg-white rounded-4 d-flex align-items-center mb-3 shadow-costom">
        <img class="mx-2" style="width: 25px;height: 25px;object-fit: fill" src="../assets/img/businessman.svg" alt="">

        <p class="m-0 font-5">
          پروفایل مجری
        </p>
      </router-link>

      <router-link :to="{name: 'MarkProducts'}" class="a_link p-3 bg-white rounded-4 d-flex align-items-center mb-3 shadow-costom">
        <img class="mx-2" style="width: 25px;height: 25px;object-fit: fill" src="../assets/img/bokmark_profile.svg" alt="">

        <p class="m-0 font-5">
          نشان شده ها
        </p>
      </router-link>

      <router-link :to="{name:'MyOrders'}" class="a_link p-3 bg-white rounded-4 d-flex align-items-center mb-3 shadow-costom">
        <img class="mx-2" style="width: 25px;height: 25px;object-fit: fill" src="../assets/img/shopping-bag_profile.svg" alt="">

        <p class="m-0 font-5">
          سفارشات من
        </p>
      </router-link>

      <router-link :to="{name:'MyWallet'}" class="a_link p-3 bg-white rounded-4 d-flex align-items-center mb-3 shadow-costom">
        <img class="mx-2" style="width: 25px;height: 25px;object-fit: fill" src="../assets/img/wallet_profile.svg" alt="">

        <p class="m-0 font-5">
          کیف پول و پرداخت ها
        </p>
      </router-link>

      <router-link :to="{name:'MyAdvers'}" class="a_link p-3 bg-white rounded-4 d-flex align-items-center mb-3 shadow-costom">
        <img class="mx-2" style="width: 25px;height: 25px;object-fit: fill" src="../assets/img/search_1_.svg" alt="">

        <p class="m-0 font-5">
          آگهی های من
        </p>
      </router-link>

      <router-link :to="{name:'MyChats'}" class="a_link p-3 bg-white rounded-4 d-flex align-items-center mb-3 shadow-costom">
        <img class="mx-2" style="width: 25px;height: 25px;object-fit: fill" src="../assets/img/chat-web.svg" alt="">

        <p class="m-0 font-5">چت های من</p>
      </router-link>

      <router-link to="BuyEducations" class="a_link p-3 bg-white rounded-4 d-flex align-items-center mb-3 shadow-costom">
        <img class="mx-2" style="width: 25px;height: 25px;object-fit: fill" src="../assets/img/webinar.svg" alt="">

        <p class="m-0 font-5">
          دوره های خریداری شده
        </p>
      </router-link>

      <router-link :to="{name: 'RulesPage' , params:{action:'ruls'}}" class="a_link p-3 bg-white rounded-4 d-flex align-items-center mb-3 shadow-costom">
        <img class="mx-2" style="width: 25px;height: 25px;object-fit: fill" src="../assets/img/updated.svg" alt="">

        <p class="m-0 font-5">
          قوانین و مقررات
        </p>
      </router-link>

      <router-link :to="{name: 'RulesPage' , params:{action:'about_us'}}" class="a_link p-3 bg-white rounded-4 d-flex align-items-center mb-3 shadow-costom">
        <img class="mx-2" style="width: 25px;height: 25px;object-fit: fill" src="../assets/img/team.svg" alt="">

        <p class="m-0 font-5">
          درباره ما
        </p>
      </router-link>

      <router-link :to="{name:'SupportPage'}" class="a_link p-3 bg-white rounded-4 d-flex align-items-center mb-3 shadow-costom">
        <img class="mx-2" style="width: 25px;height: 25px;object-fit: fill" src="../assets/img/phone-call.svg" alt="">

        <p class="m-0 font-5">
          ارتباط با پشتیبانی
        </p>
      </router-link>

      <a href="https://decoban.ir/assets/app/Decoban.apk" class="a_link p-3 bg-white rounded-4 d-flex shadow-costom align-items-center mb-3">
        <img class="mx-2" style="width: 25px;height: 25px;object-fit: fill" src="../assets/img/64px-Download-Icon.png" alt="">

        <p class="m-0 font-5">
          دانلود اپلیکیشن
        </p>
      </a>

      <a href="https://decoban.ir/assets/app/DecobanShop.apk" class="a_link p-3 bg-white rounded-4 shadow-costom d-flex align-items-center mb-3">
        <img class="mx-2" style="width: 25px;height: 25px;object-fit: fill" src="../assets/img/64px-Download-Icon.png" alt="">

        <p class="m-0 font-5">
          دانلود اپلیکیشن فروشگاه
        </p>
      </a>

      <a href="https://shop.decoban.ir" target="_blank" class="a_link p-3 bg-white rounded-4 d-flex shadow-costom align-items-center mb-3">
        <img class="mx-2" style="width: 1.5rem;;object-fit: fill" src="../assets/img/user-icon-q8s7fb75oej4ozz4h9m73qm9tdlufkjmqeqo2ipgzo.jpg" alt="">

        <p class="m-0 font-5">
          ورود به وب اپلیکیشن فروشگاه
        </p>
      </a>

      <div @click="log_out" class="a_link p-3 bg-white rounded-4 d-flex align-items-center mb-3 shadow-costom">
        <img class="mx-2" style="width: 25px;height: 25px;object-fit: fill" src="../assets/img/enter.svg" alt="">

        <p class="m-0 font-5">
          خروج از اپلیکیشن
        </p>
      </div>

    </div>

    <FooterPage></FooterPage>
  </div>

</template>

<style scoped>

.a_link {
  text-decoration: none;
  color: #1a1d20;
}

</style>